import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class FeedMatrixLine extends BasicEntity {
key: string;
way: string;
}

